import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { mobile } from "../responses";
import { login } from "../redux/apiCalls";
import { useDispatch, useSelector } from "react-redux";
import { currentUserSelector, errorSelector, isFetchingSelector } from "../redux/userRedux";
import { BrowserRouter, Navigate } from "react-router-dom";
import { Link } from "react-router-dom";


const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background: linear-gradient(
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5)
    ),
    url("https://i.ibb.co/bbfyVq6/pexels-evg-kowalievska-1126993.jpg") center center/cover;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Wrapper = styled.div`
  width: 25%;
  background-color: white;
  padding: 20px;
  ${mobile({ width: "75%" })};
`;
const Title = styled.h1`
  font-style: 24px;
  font-weight: 300;
`;
const Form = styled.form`
  display: flex;
  flex-direction: column;
`;
const Input = styled.input`
  flex: 1;
  margin: 10px 0px;
  min-width: 40%;
  padding: 10px;
`;
const Button = styled.button`
  width: 40%;
  border: none;
  padding: 15px 20px;
  background-color: teal;
  color: white;
  cursor: pointer;
  margin: 10px 0px;
`;
const Lin = styled.a`
  margin: 5px 0px;
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
`;
const Error=styled.span`
    color:red;
`

const Login = () => {
  const buttonRef=useRef()
  const [username, setUsername] = useState("");
  const [password, setpassword] = useState("");
  const dispatch = useDispatch();
  const fetching=useSelector(isFetchingSelector)
  const currentUser=useSelector(currentUserSelector);
  const rror=useSelector(errorSelector)
  // console.log({rror});
  localStorage.clear()
  
  const handleLogin = (e) => {
    e.preventDefault();
    login(dispatch, { username, password });
  };

  useEffect(()=>{
    if(currentUser?.toBeSent){
    <Navigate to={"/"}/>
  }

  },[fetching,currentUser])
  // console.log({fetching,currentUser});
  
  return (
    <Container>
      <Wrapper>
        <Title>SIGN IN</Title>
        <Form onSubmit={handleLogin}>
          <Input
            spellCheck 
            placeholder="username" 
            required
            onChange={(e) => setUsername(e.target.value)}
          />
          <Input
            type="password"
            required
            placeholder="password"
            onChange={(e) => setpassword(e.target.value)}
          />
          <Button ref={buttonRef} style={{opacity:fetching?.5:1,cursor:fetching?"not-allowed":"pointer"}}>LOGIN</Button>
         {rror && <Error>Something went wrong...</Error>}
         <Link to={'/'} style={{fontSize:"14px"}} >
          DO NOT YOU REMEMBER THE PASSWORD?
         </Link>
         <Link style={{fontSize:"14px"}} to={"/register"}>
          CREATE NEW ACCOUNT
         </Link>
        </Form>
      </Wrapper>
    </Container>
  );
};

export default Login;
